<template>
  <b-dropdown ref="dropdown" position="is-bottom-left">
    <button class="button" slot="trigger">
      <b-icon icon="clock"></b-icon>
      <slot></slot>
    </button>
    <month-picker @change="showDate"></month-picker>

    <button class="button mt-2 mr-2 is-pulled-right is-primary is-outlined" @click="submit">Calculate</button>
    <button class="button mt-2 mr-2 is-pulled-right is-primary is-outlined" @click="reportDownload">Download
      Report</button>
    <span class="is-clearfix"></span>
  </b-dropdown>
</template>

<script>
//import { MonthPicker } from 'vue-month-picker'

export default {
  // components: {
  //   MonthPicker
  // },

  methods: {
    showDate(date) {
      this.date = date;
      let options = this.date;
      this.$emit("submit", options);
    },

    submit(toggle = true) {

      this.$emit("calculate");
      if (toggle) {
        this.$refs.dropdown.toggle();
      }
    },

    reportDownload(toggle = true) {

      this.$emit("reportDownload");
      if (toggle) {
        this.$refs.dropdown.toggle();
      }
    }
  }
};
</script>
